import { IResultWithPagination } from 'reducers/models'

export interface IExtraDocumentConfigurationListModel {
    id: number,
    type: string,
    shipper: string,
    consignee: string,
    portOfLoad: string,
    portOfDischarge?: string,
    transportationMode: string,
    salesOrganization: string,
    division: string,
    soldToParty: string,
    createdBy: string,
    createdOn: string,
    updatedBy: string,
    updatedOn: string,
    isDeleted: boolean | string
}

export interface IExportExtraDocumentConfigurations extends IResultWithPagination<IExportExtraDocumentConfiguration> { }

export interface IExportExtraDocumentConfiguration {
    productType?: string
    id?: number,
    type?: string,
    shipper: string,
    consignee: string,
    portOfLoad: string,
    placeOfReceipt: string,
    originService: string,
    destinationService: string,
    transportationMode: TransportMode | string,
    incoTerm?: string,
    prefix: string,
    companyCode: string,
    salesOrganization: string,
    division: string,
    documentIssuerCountryCode: string,
    documentIssuerBusinessEntityCode: string,
    documentIssuerFunctionCode: string,
    salesOffice: string,
    plant: string,
    createdBy?: string,
    createdOn?: string,
    updatedBy?: string,
    updatedOn?: string,
    isDeleted?: boolean | string,
    timeStamp?: string,
    productTypeExport?: string
}

export const EmptyExportExtraDocumentConfiguration: IExportExtraDocumentConfiguration = {
    id: 0,
    shipper: '',
    consignee: '',
    portOfLoad: '',
    placeOfReceipt: '',
    originService: '',
    destinationService: '',
    transportationMode: 'SEA',
    incoTerm: '',
    prefix: '',
    companyCode: '',
    salesOrganization: '',
    division: '',
    documentIssuerCountryCode: '',
    documentIssuerBusinessEntityCode: '',
    documentIssuerFunctionCode: '',
    salesOffice: '',
    plant: '',
    createdBy: '',
    createdOn: '',
    updatedBy: '',
    updatedOn: '',
    isDeleted: false,
    productTypeExport: '',
    productType: ''
}

export interface IImportExtraDocumentConfigurations extends IResultWithPagination<IImportExtraDocumentConfiguration> { }
export interface IImportExtraDocumentConfiguration {
    id?: number,
    type?: string,
    consignee: string,
    portOfLoad: string,
    clientPlaceOfDelivery: string,
    placeOfReceipt: string,
    carrierPlaceOfDelivery: string,
    portOfDischarge: string,
    originService: string,
    destinationService: string,
    transportationMode: TransportMode | string,
    incoTerm?: string,
    companyCode: string,
    salesOrganization: string,
    division: string,
    salesOffice: string,
    plant: string,
    createdBy?: string,
    createdOn?: string,
    updatedBy?: string,
    updatedOn?: string,
    isDeleted?: boolean | string,
    timeStamp?: string,
    productTypeImport?: string
    productType?: string

}

export const EmptyImportExtraDocumentConfiguration: IImportExtraDocumentConfiguration = {
    id: 0,
    consignee: '',
    portOfLoad: '',
    clientPlaceOfDelivery: '',
    placeOfReceipt: '',
    carrierPlaceOfDelivery: '',
    portOfDischarge: '',
    originService: '',
    destinationService: '',
    transportationMode: 'SEA',
    incoTerm: '',
    companyCode: '',
    salesOrganization: '',
    division: '',
    salesOffice: '',
    createdBy: '',
    createdOn: '',
    updatedBy: '',
    updatedOn: '',
    isDeleted: false,
    plant: '',
    productTypeImport: '',
    productType: ''
}

export interface IToggleActiveExtraDocumentConfiguration {
    id: number,
    isDeleted?: boolean,
    updatedBy?: string
}

export enum TransportMode {
    SEA = 'SEA',
    AIR = 'AIR',
    RAIL = 'RAIL',
    TRUCK = 'TRUCK',
    OCEAN = 'OCEAN'
}
